import { useMutation } from 'react-query';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';

export interface VerifyTrackingResponse {
  found: boolean;
  retryAfterSeconds?: number;
}

export const useVerifyTracking = () => useMutation<VerifyTrackingResponse, unknown, void>(
  async () => {
    const res = await dataFetch.post(
      `${CORE_API_SUFFIX}digger-core-api/onboarding/verify-tracking`,
    );
    return res.data?.data ?? res.data;
  },
);
